import { create } from 'zustand';
import type { GeoLevel } from '@/types/geography';

interface FlyToTarget {
  lat: number;
  lon: number;
  zoom?: number;
}

interface UiState {
  selectedGeoId: string | null;
  geoLevel: GeoLevel;
  /**
   * When true, MapZoomGeoLevelController drives geoLevel automatically from
   * the live Leaflet zoom level (zooming in reveals ZIP boundaries, zooming
   * back out returns to county) -- the literal "when the user zooms in...
   * it shows..." behavior. Picking a layer manually from MapControls'
   * dropdown turns this off so the explicit choice sticks; the dropdown's
   * own "Auto (zoom)" option turns it back on.
   */
  autoGeoLevel: boolean;
  isDrawerOpen: boolean;
  compareGeoId: string | null; // scaffolded for ENABLE_COMPARE_MODE
  flyToTarget: FlyToTarget | null;

  selectGeo: (geoId: string) => void;
  closeDrawer: () => void;
  /** Manual selection (e.g. the Layer dropdown) -- disables auto zoom-driven switching. */
  setGeoLevel: (level: GeoLevel) => void;
  /** Zoom-driven selection (MapZoomGeoLevelController) -- does not touch autoGeoLevel. */
  setGeoLevelFromZoom: (level: GeoLevel) => void;
  setAutoGeoLevel: (auto: boolean) => void;
  setCompareGeo: (geoId: string | null) => void;
  requestFlyTo: (target: FlyToTarget) => void;
  clearFlyToTarget: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  selectedGeoId: null,
  geoLevel: 'county',
  autoGeoLevel: true,
  isDrawerOpen: false,
  compareGeoId: null,
  flyToTarget: null,

  selectGeo: (geoId) => set({ selectedGeoId: geoId, isDrawerOpen: true }),
  closeDrawer: () => set({ isDrawerOpen: false }),
  setGeoLevel: (level) => set({ geoLevel: level, autoGeoLevel: false }),
  setGeoLevelFromZoom: (level) => set({ geoLevel: level }),
  setAutoGeoLevel: (auto) => set({ autoGeoLevel: auto }),
  setCompareGeo: (geoId) => set({ compareGeoId: geoId }),
  requestFlyTo: (target) => set({ flyToTarget: target }),
  clearFlyToTarget: () => set({ flyToTarget: null }),
}));
